/* tslint:disable */
/* eslint-disable */

/**
 * Where a record was created. A missing value means INTERNAL.
 */
export enum RecordOrigin {
  Internal = 'INTERNAL',
  Fbo = 'FBO',
}
